import { render, staticRenderFns } from "./RemoveVideoInstructionsDialog.vue?vue&type=template&id=fc3b7e82&scoped=true"
import script from "./RemoveVideoInstructionsDialog.vue?vue&type=script&lang=js"
export * from "./RemoveVideoInstructionsDialog.vue?vue&type=script&lang=js"
import style0 from "./RemoveVideoInstructionsDialog.vue?vue&type=style&index=0&id=fc3b7e82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3b7e82",
  null
  
)

export default component.exports